import './TypingIndicator.css';

const TypingIndicator = ({ text = 'Thinking...', showDots = true }) => {
  return (
    <div className="typing-indicator">
      {showDots && (
        <div className="typing-dots">
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
          <div className="typing-dot"></div>
        </div>
      )}
      <span className="typing-text">{text}</span>
    </div>
  );
};

export default TypingIndicator;